module.exports = __webpack_public_path__ + "static/media/Asset2.1e4c82a7.png";